export enum UserRole {
  Admin = 'admin',
  Agent = 'agent',
  Client = 'client',
}

export enum TicketStatus {
  Open = 'open',
  InProgress = 'in_progress',
  Waiting = 'waiting',
  Resolved = 'resolved',
  Closed = 'closed',
}

export enum TicketPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical',
}

export enum SupportType {
  BugFree = 'bug_free',
  Normal = 'normal',
}

export enum TicketSource {
  Web = 'web',
  Email = 'email',
  Enquiry = 'enquiry',
}

export enum SenderType {
  Client = 'client',
  Agent = 'agent',
  Admin = 'admin',
  System = 'system',
}

export enum EnquiryStatus {
  New = 'new',
  InProgress = 'in_progress',
  Converted = 'converted',
  Closed = 'closed',
}

export enum EnquirySource {
  Email = 'email',
  WebForm = 'web_form',
}

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
  [TicketStatus.Open]: 'Open',
  [TicketStatus.InProgress]: 'In Progress',
  [TicketStatus.Waiting]: 'Waiting',
  [TicketStatus.Resolved]: 'Resolved',
  [TicketStatus.Closed]: 'Closed',
}

export const TICKET_PRIORITY_LABELS: Record<TicketPriority, string> = {
  [TicketPriority.Low]: 'Low',
  [TicketPriority.Medium]: 'Medium',
  [TicketPriority.High]: 'High',
  [TicketPriority.Critical]: 'Critical',
}

export const KANBAN_COLUMNS: TicketStatus[] = [
  TicketStatus.Open,
  TicketStatus.InProgress,
  TicketStatus.Waiting,
  TicketStatus.Resolved,
  TicketStatus.Closed,
]
